<div class="recoverable-error-modal-container"></div>

<h1 id="step-heading" class="step-heading">
  <% if (validated_ehr_appointment_slot_id && provider.gid == validated_provider.gid) { %>
    <%= I18n.confirmation.headings.confirm_details %>
  <% } else if (provider.gid != validated_provider.gid && !validated_visit_types.length) { %>
    <%= I18n.confirmation.headings.pcp_unavailable %>
  <% } else { %>
    <%= I18n.confirmation.headings.change_needed %>
  <% } %>
</h1>

<div class="step-form">
  <div class="summary-container"></div>
  <div class="provider-switch-callout-container"></div>
  <div class="slot-reselector-container"></div>
  <div class="platform-select-container"></div>

  <% _.each(review_step_broadcasts, function(broadcast) { %>
    <sp-broadcast
      level="<%= broadcast.level %>"
      <% if (broadcast.icon) { %>icon="<%= broadcast.icon %>"<% } %>
      <% if (broadcast.collapsable) { %>collapsable<% } %>
      <% if (broadcast.dismissable) { %>dismissable<% } %>
    >
      <% if (broadcast.title) { %>
        <span slot="title"><%= broadcast.title %></span>
      <% } %>
      <div class="broadcast-message-text"><%= broadcast.text %></div>
    </sp-broadcast>
  <% }); %>

  <div class="insurance-container"></div>
  <div class="reason-for-visit-container"></div>
</div>
